import { useEffect, useState, useContext, useRef } from 'react';
import { GlobalState } from "./../../../context/globalState";
import { Row, Col, Form, Input, Select, DatePicker, Checkbox, message, Popconfirm } from "antd"
import AdAndEdit from "./../components/modal/adAndEdit";
import MDDelete from "./../components/modal/mdDeleteAlert";
import Button from "./../../../components/button/index";
import Server from "./../../../lib/getAPI";
import dayjs from "dayjs";
import Images from "./../../../asset/exportImages";
import { trackProductEvent } from '../../../lib/trackingService';

const BuyerInfo = () => {
  const { setLoading, isMobile, listOfInsuredPeople, Helper, ActionList, buyerInfo, setBuyerInfo, setStep, setDataFees, dataFees, packages, dataOrder, messageErr, scrollIntoViewID, validatePeople, setListOfInsuredPeople } = useContext(GlobalState);
  const [openMD, setOpenMD] = useState(false);
  const [warningDelete, setWarningDelete] = useState({
    open: false,
    nameData: []
  });
  const [idEdit, setIdEdit] = useState(undefined);
  const [form] = Form.useForm();
  const today = dayjs();
  const minDate = today.subtract(75, "year")
  const maxDate = today.subtract(18, "year")
  const importInputRefCCCD = useRef();
  const [submittable, setSubmittable] = useState(false);
  const values = Form.useWatch([], form);

  useEffect(() => {
    window.scrollTo(0, 0);
    trackProductEvent("product_insurance_form_started", {
      product_id: 93,
    });
    validateAgeInList(listOfInsuredPeople);
  }, []);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      form
        .validateFields({ validateOnly: true })
        .then(() => setSubmittable(true))
        .catch(() => setSubmittable(false))
    }, 500);
    if (listOfInsuredPeople?.[0]?.self) {
      setBuyerInfo({ ...buyerInfo, buyYourSelf: true, ...values });
      if (validatePeople(values?.buyerPrivateId, 0)) {
        form.setFieldsValue({ buyerPrivateId: undefined });
        return
      }
      if (!values?.buyerName || !values?.buyerDob || !values?.buyerPrivateId) {
        ActionList("delete", 0, "");
        return
      }
      ActionList('edit', 0,
        {
          "insuredName": values?.buyerName,
          "insuredDob": values?.buyerDob,
          "insuredPrivateId": values?.buyerPrivateId,
          "self": true
        });
    } else {
      if (validatePeople(values?.buyerPrivateId, -1)) {
        form.setFieldsValue({ buyerPrivateId: undefined });
        return
      }
      if (values?.buyerName && values?.buyerDob && values?.buyerPrivateId) {
        ActionList('unshift', '',
          {
            "insuredName": values?.buyerName,
            "insuredDob": values?.buyerDob,
            "insuredPrivateId": values?.buyerPrivateId,
            "self": true
          });
      }
      setBuyerInfo({ ...buyerInfo, buyYourSelf: true, ...values });
    }
    return () => clearTimeout(timeoutId);
  }, [form, values]);

  // Tính phí bảo hiểm
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDataFees({
        ...dataFees,
        totalInsured: (listOfInsuredPeople?.length || 1) * dataOrder?.fees,
      });
    }, 500);
    return () => clearTimeout(timeoutId);
  }, [listOfInsuredPeople?.length]);


  const disabledDate = (current) => {
    if (!current) return false;
    return current.isBefore(minDate, "day") || current.isAfter(maxDate, "day");
  };

  // Hiện tại chỉ bắt cho Liberty
  const calculateAge = (dob) => {
    const birthDate = dayjs(dob);
    const minDate = dayjs().subtract(75, "year")
    const maxDate = dayjs().subtract(15, "days").add(1, 'days');

    return (
      birthDate.isAfter(minDate) ||
      birthDate.isSame(minDate, "day")
    ) && (
        birthDate.isBefore(maxDate) ||
        birthDate.isSame(maxDate, "day")
      );
  };

  const validateAgeInList = (list) => {
    const validList = [];
    const removedPeople = [];
    if (!list.length) return;
    list.forEach((person) => {
      const validateAge = calculateAge(person.insuredDob);
      if (validateAge) {
        validList.push(person);
      } else {
        if (person.self) { form.setFieldsValue({ 'buyYourSelf': undefined }) }
        setBuyerInfo({ ...buyerInfo, buyYourSelf: undefined });
        removedPeople.push(person.insuredName);
      }
    });
    if (removedPeople.length) {
      setWarningDelete({ open: true, nameData: removedPeople })
    }
    setListOfInsuredPeople([...validList]);
    return { validList, removedPeople };
  };

  const isValidBuyerDob = (dob) => {
    if (!dob) return false;
    const dob2 = dayjs(dob)
    const minDate = dayjs().subtract(75, "year");
    const maxDate = dayjs().subtract(18, "year");
    return (
      (dob2.isAfter(minDate) || dob2.isSame(minDate)) &&
      (dob2.isBefore(maxDate) || dob2.isSame(maxDate))
    );
  };

  const onFinish = (val) => {
    form
      .validateFields()
      .then(async (values) => {
        if (!isValidBuyerDob(values?.buyerDob)) {
          trackProductEvent("product_insurance_validation_failed", {
            error_code: "INVALID_BUYER_AGE",
          });
          message.error('Người mua phải trên 18 tuổi!');
          form.setFieldsValue({
            buyYourSelf: undefined,
            buyerName: undefined,
            buyerDob: undefined,
            buyerPrivateId: undefined,
            buyerAddress: undefined,
          })
          return
        }
        setBuyerInfo({ ...buyerInfo, ...values });
        if (listOfInsuredPeople.length === 0) {
          trackProductEvent("product_insurance_validation_failed", {
            error_code: "EMPTY_INSURED_LIST",
          });
          message.error('Vui lòng thêm người được bảo hiểm');
          return;
        }
        trackProductEvent("product_insurance_submitted", {
          form_id: "tnhgd_insurance_form",
        });
        setStep(4);
      })
      .catch((err) => {
        trackProductEvent("product_insurance_validation_failed", {
          error_code: "FORM_VALIDATION_FAILED",
        });
        console.error("err:", err);
      });
  };

  const handelCanCel = () => {
    setOpenMD(false);
    setIdEdit(undefined);
    setWarningDelete({
      open: false,
      name: []
    });
  }

  const handleImportFile = async (files) => {
    if (!files?.[0]) return;
    trackProductEvent("product_insurance_file_upload", {
      file_type: "cccd_ocr",
    });
    setLoading(true);
    message.warning("Hình ảnh đang được xử lý!");

    try {
      // 1) Upload
      const uploadForm = new FormData();
      uploadForm.append("file", files[0]);
      uploadForm.append("productCode", "tnhgd");
      const uploadRes = await Server.apiCallOpenVerify("POST", "/v1/products/upload/private-id", uploadForm);
      const uploadData = uploadRes?.data;
      if (!uploadData?.success) throw new Error("Upload thất bại");

      const link = uploadData.data.url;

      // 2) OCR
      const ocrPayload = { privateIdFrontUrl: link };
      const ocrRes = await Server.apiCallOpenVerify("POST", "/v1/ocr/private-id", ocrPayload);
      const ocrData = ocrRes?.data;

      if (ocrData?.success) {
        // cập nhật state / form
        setBuyerInfo((prev) => ({ ...prev, buyYourSelf: undefined, privateIdUrl: link }));
        const idInfo = ocrData.data?.idCardInfo || {};
        const dobFormat = idInfo.dob ? dayjs(idInfo.dob, "DD/MM/YYYY") : undefined;

        form.setFieldsValue({
          buyYourSelf: undefined,
          buyerName: idInfo.name || undefined,
          buyerDob: dobFormat,
          buyerPrivateId: idInfo.id || undefined,
          buyerAddress: idInfo.address || undefined,
          // buyerGender: idInfo.gender ? (idInfo.gender === "Nam" ? "MALE" : "FEMALE") : undefined,
        });

        message.success("Hình ảnh được xử lý thành công!");
      } else {
        // trường hợp API trả lỗi dạng code
        if (ocrData?.code) messageErr(ocrData.code);
        else message.error("Xử lý OCR thất bại");
      }
    } catch (err) {
      if (err?.response?.data?.message) {
        message.error(err?.response?.data?.message);
      } else {
        message.error("Có lỗi xảy ra vui lòng kiểm tra lại!");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <input
        ref={importInputRefCCCD}
        type="file"
        accept="image/*"
        onClick={(e) => {
          e.target.value = "";
        }}
        onChange={(e) => handleImportFile(e.target.files)}
        style={{
          display: "none",
        }}
      />
      {
        openMD &&
        <AdAndEdit handelCanCel={handelCanCel} idEdit={idEdit} />
      }
      {
        warningDelete.open &&
        <MDDelete handelCanCel={handelCanCel} nameDelete={warningDelete?.nameData || []} />
      }
      <Form
        layout={"vertical"}
        // scrollToFirstError
        form={form}
        onFinish={onFinish}
        onFinishFailed={(e) => {
          trackProductEvent("product_insurance_validation_failed", {
            error_code: "FORM_VALIDATION_FAILED",
          });
          scrollIntoViewID(e?.errorFields?.[0]?.name?.[0]);
        }}
        onFocus={(e) => {
          scrollIntoViewID(e.target.id);
        }}
        onValuesChange={(changedValues, allValues) => {
          if (window.__debounceTimer) clearTimeout(window.__debounceTimer);
          window.__debounceTimer = setTimeout(() => {
            const fieldName = Object.keys(changedValues)[0];
            if (fieldName === 'beginDate') {
              form.setFieldsValue({ endDate: allValues?.beginDate ? dayjs(allValues.beginDate).add(1, 'year') : undefined });
            }
          }, 500);
        }}
        requiredMark={(label, { required }) => (
          <>
            {label}
            {required && <span style={{ color: "red", marginLeft: 4 }}>*</span>}
          </>
        )}
        initialValues={{
          ...buyerInfo,
          buyerName: buyerInfo?.buyerName ? Helper.capitalize(buyerInfo?.buyerName) : undefined,
          buyerDob: buyerInfo?.buyerDob ? dayjs(buyerInfo?.buyerDob) : undefined,
          buyYourSelf: listOfInsuredPeople?.[0]?.self ? ['banthan'] : undefined,
          beginDate: buyerInfo?.beginDate ? dayjs(buyerInfo?.beginDate) : undefined,
          endDate: buyerInfo?.endDate ? dayjs(buyerInfo?.endDate) : undefined,
        }}
      >

        <Row gutter={isMobile ? [0, 15] : [30, 15]} style={{ maxWidth: 900, margin: '0px auto' }}>
          <Col xs={24} xl={24}>
            <img src={isMobile ? Images.Banner3MB : Images.Banner3} style={{ borderRadius: isMobile ? 8 : 16, width: '100%' }} />
          </Col>
          <Col xs={24}>
            <h1 style={{ fontSize: isMobile ? 18 : 20, margin: 0, color: '#343A40' }}>
              Thông tin người mua bảo hiểm
            </h1>
          </Col>
          <Col xs={24} md={12} xl={8}>
            <div style={{ display: isMobile ? 'flex ' : 'grid', gap: 0 }}>
              {
                buyerInfo?.privateIdUrl &&
                <div style={{ padding: 5, borderRadius: isMobile ? 8 : 12, border: '0.5px solid #D2D2D2', marginRight: isMobile ? 15 : 0, width: isMobile ? '50%' : '100%', position: 'relative' }}>
                  <img height={isMobile ? '125px' : '250px'} width={'100%'} src={buyerInfo?.privateIdUrl} style={{ objectFit: 'cover', borderRadius: isMobile ? 4 : 16, marginBottom: -5 }} />
                  <img onClick={() => setBuyerInfo({ ...buyerInfo, privateIdUrl: undefined })} style={{ position: 'absolute', right: 10, top: 10, cursor: 'pointer' }} src={Images.ICXoa2} width={isMobile ? '16px' : '24px'} />
                </div>
              }
              {
                !buyerInfo?.privateIdUrl &&
                <img onClick={() => importInputRefCCCD.current.click()} width={isMobile ? '50%' : '100%'} src={isMobile ? Images.CCCDMB : Images.CCCD} style={{ marginRight: isMobile ? 15 : 0, cursor: 'pointer' }} />
              }

              <div style={{ width: isMobile ? '50%' : '' }}>
                <i style={{ fontSize: 12, color: '#FB7800' }}>
                  Chụp CCCD/hộ chiếu để nhập nhanh thông tin
                  {
                    isMobile ?
                      <span style={{ color: '#969696', fontSize: 12 }}> (không bắt buộc)</span> :
                      <div style={{ color: '#969696', fontSize: 12 }}> (không bắt buộc)</div>
                  }
                </i>
              </div>
            </div>
          </Col>
          <Col xl={16} xs={24}>
            <Row gutter={isMobile ? [15, 15] : [15, 15]}>
              <Col xl={12} md={12} xs={24}>
                <Form.Item name="buyerName" label="Họ và tên" rules={[{ required: true, message: 'Vui lòng nhập thông tin!' }]}>
                  <Input
                    allowClear
                    placeholder="Nhập họ và tên"
                    onBlur={() => trackProductEvent("product_insurance_field_input", { field_name: "buyerName" })}
                  />
                </Form.Item>
              </Col>

              <Col xl={12} md={12} xs={24}>
                <Form.Item name="buyerDob" label="Ngày sinh" rules={[{ required: true, message: 'Vui lòng chọn thông tin!' }]}>
                  <DatePicker
                    inputReadOnly
                    suffixIcon={<img src={Images.ICDate} />}
                    format={'DD/MM/YYYY'}
                    placeholder="DD/MM/YYYY"
                    disabledDate={disabledDate}
                    defaultPickerValue={buyerInfo?.buyerDob ? undefined : today.subtract(18, "year")}
                    style={{ width: '100%' }}
                    onBlur={() => trackProductEvent("product_insurance_field_input", { field_name: "buyerDob" })}
                  />
                </Form.Item>
                <i style={{ fontSize: 12, color: '#FB7800' }}>Chủ hợp đồng phải trên 18 tuổi</i>
              </Col>

              <Col xl={12} md={12} xs={24}>
                <Form.Item name="buyerPrivateId" label="CCCD/ Số định danh" rules={[{ required: true, message: 'Vui lòng nhập thông tin!' }, {
                  pattern: /^.{12,}$/,
                  message: 'CCCD/ Số định danh chưa chính xác'
                }]}>
                  <Input
                    allowClear
                    placeholder="Nhập CCCD/ Số định danh"
                    onBlur={() => trackProductEvent("product_insurance_field_input", { field_name: "buyerPrivateId" })}
                  />
                </Form.Item>
              </Col>

              <Col xl={12} md={12} xs={24}>
                <Form.Item name="buyerPhone" label="Số điện thoại" rules={[{ required: true, message: 'Vui lòng nhập thông tin!' }, {
                  message:
                    "Vui lòng nhập đúng số điện thoại",
                  pattern: /^(09|03|07|08|05)[0-9]{8}$/,
                }]}>
                  <Input
                    type="tel"
                    allowClear
                    placeholder="Nhập số điện thoại"
                    onBlur={() => trackProductEvent("product_insurance_field_input", { field_name: "buyerPhone" })}
                  />
                </Form.Item>
              </Col>

              <Col xl={12} md={12} xs={24}>
                <Form.Item name="buyerEmail" label="Email" rules={[{ required: true, message: 'Vui lòng nhập thông tin!' }, {
                  message: "Email không hợp lệ",
                  pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                },]}>
                  <Input
                    type='email'
                    allowClear
                    placeholder="Nhập email"
                    onBlur={() => trackProductEvent("product_insurance_field_input", { field_name: "buyerEmail" })}
                  />
                </Form.Item>
                <i style={{ fontSize: 12, color: '#FB7800', whiteSpace: 'nowrap' }}>Nhập Email để nhận GCN và hoá đơn VAT</i>
              </Col>

              <Col xl={12} md={12} xs={24}>
                <Form.Item name="buyerAddress" label="Địa chỉ" rules={[{ required: true, message: 'Vui lòng nhập thông tin!' }]}>
                  <Input
                    allowClear
                    placeholder="Nhập địa chỉ"
                    onBlur={() => trackProductEvent("product_insurance_field_input", { field_name: "buyerAddress" })}
                  />
                </Form.Item>
              </Col>
              <Col xl={12} md={12} xs={24}>
                <Form.Item name="beginDate" label="Ngày bắt đầu bảo hiểm" rules={[{ required: true, message: 'Vui lòng chọn thông tin!' }]}>
                  <DatePicker
                    inputReadOnly
                    suffixIcon={<img src={Images.ICDate} />}
                    format={'DD/MM/YYYY'}
                    placeholder="DD/MM/YYYY"
                    minDate={dayjs().add(1, 'days')}
                    style={{ width: '100%' }}
                    onBlur={() => trackProductEvent("product_insurance_field_input", { field_name: "beginDate" })}
                  />
                </Form.Item>
              </Col>
              <Col xl={12} md={12} xs={24}>
                <Form.Item name="endDate" label="Ngày kết thúc bảo hiểm" rules={[{ required: true, message: 'Vui lòng chọn thông tin!' }]}>
                  <DatePicker
                    inputReadOnly
                    suffixIcon={<img src={Images.ICDateDis} />}
                    format={'DD/MM/YYYY'}
                    placeholder="DD/MM/YYYY"
                    disabled
                    style={{ width: '100%' }}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Col>
          <div style={{ width: '100%', background: '#fff', padding: isMobile ? 10 : 15, borderRadius: isMobile ? 8 : 16, marginTop: isMobile ? 10 : 15 }}>
            <Row gutter={isMobile ? [0, 10] : [30, 15]}>
              <Col xs={24} xl={12} style={{ margin: 'auto 0px' }}>
                <div style={{ fontSize: isMobile ? 18 : 20, fontWeight: 600, color: '#343A40' }}>Danh sách người được bảo hiểm</div>
                <div style={{ fontSize: 12, color: '#FB7800', lineHeight: 1.2, fontStyle: 'italic', marginTop: 5 }}>Người mua bảo hiểm phải nằm trong danh sách người được bảo hiểm</div>
              </Col>
              <Col xs={24} xl={12}>
                <div style={{ display: 'flex', gap: 15, justifyContent: isMobile ? '' : 'flex-end', marginBottom: isMobile ? 5 : 10, alignItems: 'center', height: '100%' }}>
                  <div onClick={() => setOpenMD(true)} style={{ padding: '8px 12px', background: '#009B4B', fontWeight: 500, borderRadius: 8, cursor: 'pointer', color: '#fff', border: "0.5px solid #009B4B", width: isMobile ? 113 : 138, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10 }}>
                    <img src={Images.ICAdd} width={isMobile ? 20 : 20} height={isMobile ? 20 : 20} style={{}} />
                    <div>Thêm người</div>
                  </div>
                </div>
              </Col>
              {
                (listOfInsuredPeople || []).map((data, index) => (
                  <Col style={{ display: (data?.insuredDob && data?.insuredPrivateId && data?.insuredName) ? '' : 'none' }} key={index} xs={24} md={24} xl={24} >
                    <div className="card">
                      <div className="info-row success">
                        <div style={{ textTransform: 'capitalize', fontWeight: 600 }}>{data?.insuredName}</div>
                        <div style={{ color: '#343A40', cursor: 'pointer' }}>
                          {
                            !data?.self &&
                            <>
                              <img style={{ marginRight: 5 }} onClick={() => { setIdEdit(index); setOpenMD(true) }} src={Images.ICEdit} width={20} height={20} />
                              <Popconfirm
                                className="customPopup"
                                title={`Bạn muốn xoá thành viên này?`}
                                onConfirm={() => ActionList("delete", index, "")}
                                okText={"Xác nhận"}
                                cancelText="Huỷ"
                                placement="topLeft"
                              >
                                <img src={Images.ICXoa} width={20} height={20} />
                              </Popconfirm>
                            </>
                          }
                        </div>
                      </div>
                      {/* <div className="info-row gray" style={{ fontSize: 14 }}>
                        <div>Giới tính:</div>
                        <div style={{ color: '#343A40' }}><b>{data?.insuredGender === 'MALE' ? 'Nam' : 'Nữ'}</b></div>
                      </div> */}
                      <div className="info-row gray">
                        <div>Ngày sinh:</div>
                        <div style={{ color: '#343A40' }}><b>{Helper._formatDayNoHour(data?.insuredDob)}</b></div>
                      </div>
                      <div className="info-row gray">
                        <div>CCCD/Số định danh:</div>
                        <div style={{ color: '#343A40' }}><b>{data?.insuredPrivateId}</b></div>
                      </div>
                    </div>
                  </Col>
                ))
              }
            </Row>
          </div>
        </Row>
        <Button showFees={isMobile ? true : false} disabled={listOfInsuredPeople.length > 0 ? !submittable : true} />
        <style jsx>{`
        .card {
          background: #EDFBF0;
          border-radius: 16px;
          padding: 10px;
          // box-shadow: 0px 0px 8px 0px #0000001a;
          display: grid;
          gap: 10px;
          border: 0.5px solid #EDFBF0;
        }
        .info-row {
          font-size: 14px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 10px;
        }
        .info-row.gray {
          color: #646d69;
          align-items: flex-start;
        }
        .success {
          color: #009b4b;
          font-weight: 500;
        }
      `}</style>
      </Form >
    </>
  );
}

export default BuyerInfo;